import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { USER_PROFILE_EDIT_ROUTE } from 'src/app/app-routing.module';
import { environment } from "@environment";
import { AbstractComponent } from "@components";
import { CompetitorResults, Country, EventItem, Lookups, Message, Race, UserDetail } from "@model";
import { TOAST_STATE, ToastService, UserDetailService } from "@services";

@Component({
  selector: 'app-user-profile-view',
  templateUrl: './user-profile-view.component.html',
  styleUrls: ['./user-profile-view.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [
        style({ opacity: 0 }),
        animate(1600)
      ])
    ])]
})
export class UserProfileViewComponent extends AbstractComponent implements OnInit {
  @Input() countries: Country[] = [];
  @Input() genders: Lookups[] = [];
  @Input() meals: Lookups[] = [];
  @Input() transports: Lookups[] = [];
  @Input('sizes') tshirtSizes: Lookups[] = [];
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() raceUpcomingEvents: Race[] = [];
  @Input() favoriteItems: EventItem[] = [];
  @Input() races: Race[] = [];
  @Input() finishedRaces: Race[] = [];
  @Input() currentUserDetails: UserDetail | undefined;
  @Input() unreadMessages: Message[] | undefined;
  users : UserDetail[] =[];


  raceResultsMap: Map<Race, CompetitorResults[]> = new Map<Race, CompetitorResults[]>();
  editProfilePictureMode: boolean = false;
  profilePicture: string | undefined;

  constructor(private userProfile: UserDetailService, private toastService: ToastService, private router: Router,
    public translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    if (this.finishedRaces?.length  > 0) {
/*      for (let race of this.finishedRaces) {
        this.competitorResultsService.getCompetitorResultsForRace(new FetchRaceByIdRequest(race.id)).subscribe((value: CompetitorResults[]) => {
          this.raceResultsMap.set(race, value);
        });
      }*/
    }
  }

  getCountryName(): string {
    let country: Country | undefined = this.countries?.find((country: Country) => {
      return country.id === this.currentUserDetails?.country;
    });
    return country?.name ?? "-"
  }

  getTransportName(): string {
    let transport: Lookups | undefined = this.transports?.find((value: Lookups) => {
      return value.id === this.currentUserDetails?.transport;
    });
    return transport?.name ?? "-"
  }

  getTShirtSizeName(): string {
    let tshirtSize: Lookups | undefined = this.tshirtSizes?.find((value: Lookups) => {
      return value.id === this.currentUserDetails?.tshirtSize;
    });
    return tshirtSize?.name ?? "-"
  }

  getMealName(): string {
    let meal: Lookups | undefined = this.meals?.find((value: Lookups) => {
      return value.id === this.currentUserDetails?.meal;
    });
    return meal?.name ?? "-"
  }

  editProfile(): void {
    this.router.navigate([USER_PROFILE_EDIT_ROUTE]);
  }

  saveUserProfile() {
    let userDetails: UserDetail = { ...this.currentUserDetails }
    userDetails.picture = this.profilePicture;
    this.userProfile.updateUserProfile(userDetails, () => {
    }, () => {
    })
  }

  processFile(imageInput: any): void {
    if (imageInput.files?.length > 0) {
      const file: File = imageInput.files[0];
      if (file.size > environment.maxFileSize) {
        this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate("app.user.profile.max.size.error"));
      } else {
        const reader: FileReader = new FileReader();
        reader.addEventListener('load', (event: any) => {
          this.profilePicture = event.target.result;
          this.saveUserProfile();
        });
        reader.readAsDataURL(file);
      }
    }
    this.editProfilePictureMode = !this.editProfilePictureMode;
  }

  onEditProfilePicture(): void {
    this.editProfilePictureMode = !this.editProfilePictureMode;
  }

  onDeleteProfilePicture(): void {
    this.editProfilePictureMode = !this.editProfilePictureMode;
    this.profilePicture = undefined;
    this.saveUserProfile();
  }
}
